import { createI18n } from 'vue-i18n'
import * as en from '../locales/en.json'
import * as ua from '../locales/ua.json'
import * as ru from '../locales/ru.json'

export const i18n = createI18n({
  legacy: false,
  missingWarn: false,
  fallbackWarn: false,
  locale: localStorage.getItem('locale') || 'en',
  fallbackLocale: 'en',
  warnHtmlMessage: false, // disable warning HTML in message
  messages: {
    en,
    ua,
    ru
  }
})
